export function isAuthenticated() {
  return !!authenticatedEmail();
}

export function authenticatedEmail() {
  return document.authenticated_user.email
}
